// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SideWidgetUserProfileTeam_wrapper","locked":"SideWidgetUserProfileTeam_locked","content":"SideWidgetUserProfileTeam_content","mobile":"SideWidgetUserProfileTeam_mobile"};